import { performFetch } from './utils'

export function loadCountries() {
    return performFetch({ type: 'LOAD_COUNTRIES' })
}

export function loadRegions(country_code) {
    return performFetch({
        type: 'LOAD_REGIONS',
        urlData: {
            '?': { country: country_code },
        },
    })
}

export function loadCities(country_code, region, query) {
    const queryString = { country: country_code }

    if (region) {
        queryString.region = region
    }
    if (query) {
        queryString.q = query
    }

    return performFetch({
        type: 'LOAD_CITIES',
        urlData: { '?': queryString },
    })
}

export function clearCities() {
    return { type: 'CLEAR_CITIES' }
}



// WEBPACK FOOTER //
// ./app/actions/location.js